import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Next.js uses `}<a parentName="p" {...{
        "href": "https://nextjs.org/docs/app/building-your-application/routing/error-handling#using-error-boundaries"
      }}>{`error boundaries`}</a>{` to handle uncaught exceptions by rendering a fallback UI instead of the crashing components.`}</p>
    <p>{`To set one up, create a `}<inlineCode parentName="p">{`error.tsx`}</inlineCode>{` file in any of your route directories. This triggers when there is an error rendering your component and should look like this: `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx",
        "metastring": "file=error.tsx",
        "file": "error.tsx"
      }}>{`"use client";  // Error boundaries must be Client Components

import posthog from "posthog-js";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    ...
  );
}
`}</code></pre>
    <p>{`You can also create a `}<a parentName="p" {...{
        "href": "https://nextjs.org/docs/app/building-your-application/routing/error-handling#handling-global-errors"
      }}>{`Global Error component`}</a>{` in your root layout to capture unhandled exceptions in your root layout.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx",
        "metastring": "file=app/global-error.tsx",
        "file": "app/global-error.tsx"
      }}>{`'use client' // Error boundaries must be Client Components

import posthog from "posthog-js";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    // global-error must include html and body tags
    <html>
      <body>
        {/* \`NextError\` is the default Next.js error page component */}
        <NextError statusCode={0} />
      </body>
    </html>
  )
}

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      